import strapi, { mapStrapiData } from '../lib/strapi';

/**
 * Fetches both the Journey Page header and the list of Projects.
 */
export const getJourneyPageData = async () => {
  try {
    const pageRes = await strapi.get('/our-journey-page?populate=*');
    // Sort by createdAt descending since 'year' field may not exist
    const projectsRes = await strapi.get('/projects?populate=*&sort=createdAt:desc');

    return {
      content: mapStrapiData(pageRes),
      projects: projectsRes.data.data || [],
    };
  } catch (error) {
    console.error('Error fetching Journey data:', error);
    return null;
  }
};